module.exports = __webpack_public_path__ + "static/media/clip.17d245b0.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/Jiggle/Motivation/img/clip.mp4
// module id = 259
// module chunks = 0